import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';

const BaconButton = ({ className = 'baconButton', text, disabled, onClick }) => (
  <Button className={className} disabled={disabled} onClick={onClick}>{text}</Button>
);

BaconButton.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default BaconButton;